class Delegations{
  constructor() {
    this.startDate =  '';
    this.endDate = '';
    this.employeeId =  '';
    this.name= '';
    this.isNotified = false;
  }
}

export default Delegations;



// WEBPACK FOOTER //
// ./client/app/common/domain/models/delegations.js